var _circle, _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBetaListThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#08090A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.95508,
    y: 9.30432,
    width: 7.65217,
    height: 2.78261,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.95508,
    y: 14.1739,
    width: 13.913,
    height: 2.78261,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.95508,
    y: 19.0435,
    width: 13.913,
    height: 2.78261,
    fill: "white"
  })));
}

export default SvgBetaListThumb;